import {Configuration, GlobalAudioLibraryApi, GlobalImageLibraryApi} from "../api/client-axios";
import {baseUrl} from "../config/apiConfig";
import {getAccessToken} from "../authConfig/token";


export const imageUploadUrl = baseUrl + "/api/v1/administration/imageLibrary";
export const audioUploadUrl = baseUrl + "/api/v1/administration/audioLibrary";

// The generated client applies auth via the OAuth bearer scheme, which reads
// `accessToken`; the previous `apiKey` field was never consumed.
export const apiConfiguration = () => new Configuration({
    accessToken: getAccessToken(),
    basePath: baseUrl,
});

export const deleteLibraryImage = async (id: string) => {
    const api = new GlobalImageLibraryApi(apiConfiguration());
    await api.apiV1AdministrationImageLibraryIdDelete(id);
}

export const deleteLibraryAudio = async (id: string) => {
    const api = new GlobalAudioLibraryApi(apiConfiguration());
    await api.apiV1AdministrationAudioLibraryIdDelete(id);
}

